<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_REPORT_SALE_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      is-list
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      :is-pagination="false"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportSaleCensus.orderTime')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('BusinessReportSaleCensus.orderTime')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportSaleCensus.dateType')" prop="dateType">
            <BjSelectLov
              v-model="queryParams.dateType"
              :option-list="REPORT_SALE_STATISTICS_TIME_LIST"
              :placeholder="$t('BusinessReportSaleCensus.dateType')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportSaleCensus.channel')" prop="channel">
            <BjSelectLov v-model="queryParams.channel" :placeholder="$t('BusinessReportSaleCensus.channel')" lov-code="SCHL.CHANNEL_TYPE" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <BjRadioLov
            v-model="queryParams.type"
            :option-list="REPORT_SALE_STATISTICS_SUMMARY_LIST"
            :placeholder="$t('chooseText')"
          />
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <el-table-column prop="type" :label="$t('BusinessReportSaleCensus.channel')" width="120px" align="center">
          <template #header>{{
            $t(REPORT_SALE_STATISTICS_SUMMARY_LIST.bjGet(queryParams.type))
          }}</template>
          <template slot-scope="scope">
            <span v-if="queryParams.type == 1">{{ SCHL_CHANNEL_TYPE.bjGet(scope.row.type) }}</span>
            <span v-else>{{ scope.row.type }}</span>
          </template>
        </el-table-column>
        <vxe-colgroup :title="$t('BusinessReportSaleCensus.totalSales')" align="center" fixed="">
          <el-table-column prop="orderCount" :label="$t('BusinessReportSaleCensus.orderCount')" width="180" align="center" sortable>
          </el-table-column>
          <el-table-column prop="itemCount" :label="$t('BusinessReportSaleCensus.itemCount')" width="180" align="center" sortable>
          </el-table-column>
          <el-table-column prop="orderAmount" :label="$t('BusinessReportSaleCensus.goodsQuantity')" align="center" width="160" sortable>
            <template slot-scope="scope">
              {{ $number2money(scope.row.orderAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="reverseOrderCount" :label="$t('BusinessReportSaleCensus.reverseOrderCount')" align="center" width="145" sortable>
          </el-table-column>
          <el-table-column prop="reverseItemCount" :label="$t('BusinessReportSaleCensus.reverseItemCount')" align="center" width="190" sortable>
          </el-table-column>
          <el-table-column prop="reverseOrderAmount" :label="$t('BusinessReportSaleCensus.reverseOrderAmount')" align="center" width="180" sortable>
            <template slot-scope="scope">
              {{ $number2money(scope.row.reverseOrderAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="reverseItemCount" :label="$t('BusinessReportSaleCensus.reverseItem')" width="160" align="center" sortable>
          </el-table-column>
          <el-table-column prop="netSalesAmount" :label="$t('BusinessReportSaleCensus.netSalesAmount')" width="160" align="center" sortable>
            <template slot-scope="scope">
              {{ $number2money(scope.row.netSalesAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="itemCost" :label="$t('BusinessReportSaleCensus.itemCost')" width="160" align="center" sortable>
            <template slot-scope="scope">
              {{ $number2money(scope.row.itemCost) }}
            </template>
          </el-table-column>
          <el-table-column prop="itemProfit" :label="$t('BusinessReportSaleCensus.itemProfit')" width="160" align="center" sortable>
            <template slot-scope="scope">
              {{ $number2money(scope.row.itemProfit) }}
            </template>
          </el-table-column>
        </vxe-colgroup>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { reportApi } from '@/api';
import {
  BUSINESS_REPORT_SALE_ROUTE_LIST,
  REPORT_SALE_STATISTICS_TIME_LIST,
  REPORT_SALE_STATISTICS_SUMMARY_LIST,
} from '@/utils/constants';
import { disabledDate } from '../commonData';
export default {
  name: 'BusinessReportSaleCensusIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      selection: false,
      BUSINESS_REPORT_SALE_ROUTE_LIST,
      REPORT_SALE_STATISTICS_TIME_LIST,
      REPORT_SALE_STATISTICS_SUMMARY_LIST,
      /** */
      queryApi: reportApi.getOrderSaleReport,
      // 查询参数
      queryParamsTime: [],
      // 已核对字段
      queryParams: {
        dateType: 1,
        channel: null,
        type: 1,
        startDate: null,
        endDate: null,
      },
      pickerOptions: {
        // 限制时间选择一年内
        disabledDate(time) {
          return disabledDate(time);
        },
      },
      labelsVersion: 11,
      labelList: [
        {
          label: this.$t('BusinessReportSaleCensus.channelTypeMeaning'),
          prop: 'channelTypeMeaning',
          isCheck: true,
          disabled: false,
          width: '180',
        },
        {
          label: this.$t('BusinessReportSaleCensus.totalSave'),
          prop: 'totalSave',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.orderCount'),
          prop: 'orderNum',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.itemCount'),
          prop: 'goodsQuantity',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.goodsQuantity'),
          prop: 'goodsQuantity',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.reverseOrderCount'),
          prop: 'goodsQuantity',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.reverseItemCount'),
          prop: 'goodsQuantity',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.reverseOrderAmount'),
          prop: 'thirdDiscountAmount',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.reverseItem'),
          prop: 'goodsQuantity',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.netSalesAmount'),
          prop: 'businessDiscountAmount',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.itemCost'),
          prop: 'buyerPayAmount',
          isCheck: true,
          disabled: false,
        },
        {
          label: this.$t('BusinessReportSaleCensus.itemProfit'),
          prop: 'totalDiscount',
          isCheck: true,
          disabled: false,
        },
        // { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129},
      ],
    };
  },
  computed: {
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
  },
  watch: {
    queryParamsTime(v) {
      this.queryParams.startDate = (v || [])[0];
      this.queryParams.endDate = (v || [])[1];
    },
    'queryParams.type': {
      handler(v) {
        this.reFresh();
      },
    },
  },
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
